import React, { useEffect, useRef } from 'react';
import ArcGISMap from '@arcgis/core/Map';
import MapView from '@arcgis/core/views/MapView';
import Sketch from '@arcgis/core/widgets/Sketch';
import Graphic from '@arcgis/core/Graphic';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import Polygon from '@arcgis/core/geometry/Polygon';

//Componentes
import Map from './Map';

function MapContainer({ functions, states }) {
    // const { onClose } = functions;
    const { isOpen, VineyardData } = states;

    let layerEdition = new GraphicsLayer();

    const webmap = new ArcGISMap({
        basemap: 'hybrid',
        layers: [layerEdition],
    });

    const app = {
        map: webmap,
        center: [-55.765835, -32.522779],
        scale: 25000,
        spatialReference: {
            wkid: 102100,
        },
    };

    let view = new MapView(app);

    const initialize = async (container) => {
        view.container = container;
        view.when().then(() => console.log('Map and View are ready'));
    };

    if (VineyardData) {
        let cuadros = [];

        for (const Cuadro of VineyardData.cuadros) {
            // console.log(Cuadro);
            const polygon = new Polygon({
                rings: Cuadro.rings,
                spatialReference: view.spatialReference,
            });

            const fillSymbol = {
                type: 'simple-fill', // autocasts as new SimpleFillSymbol()
                color: [227, 139, 79, 0.5],
                outline: {
                    // autocasts as new SimpleLineSymbol()
                    color: [255, 255, 255],
                    width: 1,
                },
            };

            const CuadroGraphic = new Graphic({
                geometry: polygon,
                symbol: fillSymbol,
                attributes: {
                    NroCuadro: Cuadro.n_Cuadro,
                    Area: Cuadro.area + 'm²',
                    Viñedo: Cuadro.viniedo,
                    Geocodigo: Cuadro.codigo,
                    Variedad: Cuadro.variedad,
                    Plantas: Cuadro.plantas,
                    Sist_Cond: Cuadro.sist_Cond,
                    Porta_Injerto: Cuadro.port_Inj,
                    Año_Implantacion: Cuadro.ano_Impl,
                    Origen_Plantas: Cuadro.origen_Plantas,
                    Distancia_Entre_Filas: Cuadro.distancia_Entre_Filas,
                    Distancia_Entre_Plantas: Cuadro.distancia_Entre_Plantas,
                },
                popupTemplate: {
                    // autocasts as new PopupTemplate()
                    title: 'Cuadro: {NroCuadro}',
                    content: [
                        {
                            type: 'fields',
                            fieldInfos: [
                                {
                                    fieldName: 'Area',
                                },
                                {
                                    fieldName: 'Viñedo',
                                },
                                {
                                    fieldName: 'Geocodigo',
                                },
                                {
                                    fieldName: 'Variedad',
                                },
                                {
                                    fieldName: 'Sist_Cond',
                                },
                                {
                                    fieldName: 'Porta_Injerto',
                                },
                                {
                                    fieldName: 'Año_Implantacion',
                                },
                                {
                                    fieldName: 'Origen_Plantas',
                                },
                                {
                                    fieldName: 'Distancia_Entre_Filas',
                                },
                                {
                                    fieldName: 'Distancia_Entre_Plantas',
                                },
                            ],
                        },
                    ],
                },
            });

            layerEdition.graphics.add(CuadroGraphic);

            cuadros.push(CuadroGraphic);
        }

        view.goTo(cuadros).then(() => view.goTo(cuadros));
    }

    const mapDiv = useRef(null);

    useEffect(() => {
        if (mapDiv.current) {
            initialize(mapDiv.current);

            view.zoom = 6;
        }
    }, []);

    return <Map states={{ mapDiv }} />;
}

export default MapContainer;
